import React, { Component } from "react";
import PanelHeader from "../../components/PanelHeader/PanelHeader";
import { Card, CardBody, Col, CardHeader, Row } from "reactstrap";
import {
  Table,
  Tag,
  Dropdown,
  Button,
  Space,
  message,
  Modal,
  Popover,
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  MoreOutlined,
  CopyOutlined,
  EyeOutlined,
  TeamOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import axios from "axios";

class ContractConditions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openAlert: false,
      current_id: "",
      conditions: [],
    };
  }
  componentDidMount() {
    axios
      .get("https://backoffice.nadu.xyz/api/contract-conditions")
      .then((res) => {
        if (typeof res !== "undefined") {
          const formatted = res.data.data.map((element) => {
            const created_date = element.created_date;
            const updated_date = element.updated_date;
            const published_date = element.published_date;
            const last_update = published_date
              ? published_date
              : updated_date
                ? updated_date
                : created_date;
            return {
              key: element.id,
              id: element.id,
              uuid: element.uuid,
              title: element.title,
              modality: element.modality,
              isPublished: element.isPublished,
              created_date: created_date,
              updated_date: updated_date,
              published_date: published_date,
              last_update: last_update,
              author_uuid: element.author_uuid,
              collaborators: element.collaborators,
            };
          });
          this.setState({ conditions: formatted });
        }
      });
  }
  async handleDelete(contract_id) {
    try {
      const result = await axios.delete(
        `https://backoffice.nadu.xyz/api/contract-conditions/${contract_id}}`
      );
      if (result.data.error) {
        message.error(result.data.error);
      } else {
        this.setState({
          conditions: [...this.state.conditions].filter(
            (elem) => elem.id !== contract_id
          ),
        });
        message.success("Borrador eliminado correctamente");
      }
    } catch (error) {
      message.error(JSON.parse(error));
    }
  }
  async getFullContract(id) {
    const res = await axios.get(
      `https://backoffice.nadu.xyz/api/contract-conditions/${id}`
    );
    if (typeof res !== "undefined") {
      const fullResponse = res.data.data;
      return {
        title: fullResponse.attributes.title,
        text: fullResponse.attributes.text,
        modality: fullResponse.attributes.modality,
      };
    }
  }
  async handleNewRevision(id) {
    try {
      const fullContract = await this.getFullContract(id);
      const result = await axios.post(
        "https://backoffice.nadu.xyz/api/contract-conditions/",
        {
          title: fullContract.title,
          text: fullContract.text,
          author_uuid: this.props.mainState.user.uuid,
          modality: fullContract.modality,
        }
      );
      if (result.data.error) {
        message.error(result.data.error);
      } else {
        const fullResponse = result.data;
        message.success("Nueva revisión creada");
        this.props.history.push(
          `/backoffice/condiciones-contratacion/${fullResponse.id}`
        );
      }
    } catch (error) {
      console.error(error);
    }
  }
  render() {
    const columns = [
      {
        title: "Título",
        dataIndex: "title",
        key: "title",
      },
      {
        title: "Modalidad",
        dataIndex: "modality",
        key: "modality",
        render: (modality) => (
          <Tag color={modality === "business" ? "blue" : "purple"}>
            {modality === "business" ? "Empresas" : "Residencial"}
          </Tag>
        ),
      },
      {
        title: "Estado",
        dataIndex: "isPublished",
        key: "isPublished",
        render: (isPublished) => (
          <Tag color={isPublished ? "green" : "orange"}>
            {isPublished ? "Publicado" : "Borrador"}
          </Tag>
        ),
      },
      {
        title: "Última Modificación",
        dataIndex: "last_update",
        key: "last_update",
        render: (timestamp) => dayjs(parseInt(timestamp)).format("DD/MM/YYYY"),
      },
      {
        title: "Autor",
        dataIndex: "author_uuid",
        key: "author_uuid",
        render: (_, options) => (
          <Space
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 8,
            }}
          >
            <p style={{ margin: 0 }}>{options.author_uuid}</p>
            <Popover
              content={
                <div>
                  {options.collaborators && options.collaborators.length > 0 ?
                    options.collaborators.map((colab, idx) => (
                      <p key={idx}>- {colab}</p>
                    ))
                    :
                    "Sin colaboradores"
                  }
                </div>
              }
              title="Colaboradores"
              trigger="hover"
              placement="bottom"
            >
              <TeamOutlined
                style={{ fontSize: "24px", color: "#CED4D8", padding: 6 }}
              />
            </Popover>

          </Space>
        ),
      },
      {
        title: "",
        dataIndex: "action",
        key: "action",
        render: (_, options) => (
          <Dropdown
            menu={{
              items: [
                {
                  label: "Ver",
                  key: "view-section",
                  icon: <EyeOutlined />,
                  onClick: () =>
                    this.props.history.push(
                      `/backoffice/condiciones-contratacion/${options.id}?view=true`
                    ),
                },
                {
                  label: "Revisión",
                  key: "review-section",
                  disabled: !options.isPublished,
                  icon: <CopyOutlined />,
                  onClick: () => this.handleNewRevision(options.id),
                },
                {
                  label: "Editar",
                  key: "edit-section",
                  icon: <EditOutlined />,
                  disabled: options.isPublished,
                  onClick: () =>
                    this.props.history.push(
                      `/backoffice/condiciones-contratacion/${options.id}`
                    ),
                },
                {
                  danger: true,
                  label: "Eliminar",
                  key: "eliminar-contrato",
                  icon: <DeleteOutlined />,
                  disabled: options.isPublished,
                  onClick: () =>
                    this.setState({ openAlert: true, current_id: options.id }),
                },
              ],
            }}
            placement="bottom"
          >
            <Button>
              <Space>
                Acciones
                <div className="acciones-contrato">
                  <MoreOutlined />
                </div>
              </Space>
            </Button>
          </Dropdown>
        ),
      },
    ];

    return (
      <div>
        <PanelHeader size="sm" />
        <div className="content">
          <Row>
            <Col xs={12}>
              <Card>
                <CardHeader
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <h5>Lista de condiciones de contratación</h5>
                  <Button
                    type="primary"
                    onClick={() =>
                      this.props.history.push(
                        `/backoffice/condiciones-contratacion/nueva-revision`
                      )
                    }
                  >
                    Añadir nuevo archivo
                  </Button>
                </CardHeader>
                <CardBody
                  style={{
                    minHeight: "70vh",
                    display: "flex",

                    justifyContent: "center",
                  }}
                >
                  {this.state.conditions.length > 0 ? (
                    <Table
                      columns={columns}
                      dataSource={this.state.conditions}
                      style={{ width: "100%" }}
                    />
                  ) : (
                    <LoadingOutlined style={{ fontSize: "28px" }} />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
        {/* Delete Validation Modal  */}
        <Modal
          open={this.state.openAlert}
          title="Eliminar elemento"
          closeIcon={false}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            gap: "15px",
          }}
          footer={() => (
            <div
              style={{
                marginTop: 12,
                display: "flex",
                justifyContent: "center",
                gap: 12,
              }}
            >
              <Button onClick={() => this.setState({ openAlert: false })}>
                Cancelar
              </Button>
              <Button
                onClick={() => {
                  this.handleDelete(this.state.current_id);
                  this.setState({ openAlert: false, current_id: "" });
                }}
                type="primary"
                danger={true}
              >
                Eliminar
              </Button>
            </div>
          )}
        >
          ¿Deseas eliminar el elemento?
        </Modal>
      </div>
    );
  }
}

export default ContractConditions;



// WEBPACK FOOTER //
// ./src/views/Configurator/ContractConditions.jsx